<template>
  <div class="modal-sheet">
    <div class="category-editor card">
      <form class="card-body">
        <!-- Category Name Input -->
        <div class="form-group">
          <label for="categoryName">Category Name</label>
          <input
            type="text"
            class="form-control"
            id="categoryName"
            v-model="localCategoryName"
            placeholder="Category Name"
          />
        </div>

        <!-- <div class="form-group">
        <label for="accentName">Accent Color</label>
        <div class="radio-container border p-2 border-Control"> -->
        <!-- Dark Green Radio Button -->
        <!-- <input
            type="radio"
            id="colorDarkGreen"
            class="rdobutton_radio"
            name="colorOptions"
          />
          <label
            for="colorDarkGreen"
            class="rdobutton_label"
            style="background-color: #91c13a; border-color: #91c13a"
          ></label> -->

        <!-- Dark Purple Radio Button -->
        <!-- <input
            type="radio"
            id="colorDarkPurple"
            class="rdobutton_radio"
            name="colorOptions"
          />
          <label
            for="colorDarkPurple"
            class="rdobutton_label"
            style="background-color: #ae76ff; border-color: #ae76ff"
          ></label>

           Light Blue Radio Button -->
        <!-- <input
        type="radio"
        id="colorLightBlue"
        class="rdobutton_radio"
        name="colorOptions"
      />
      <label
        for="colorLightBlue"
        class="rdobutton_label"
        style="background-color: #d6e0f5; border-color: #d6e0f5"
      ></label> -->

        <!-- Light Yellow Radio Button -->
        <!-- <input
            type="radio"
            id="colorLightYellow"
            class="rdobutton_radio"
            name="colorOptions"
          />
          <label
            for="colorLightYellow"
            class="rdobutton_label"
            style="background-color: #f1c044; border-color: #f1c044"
          ></label>
        </div>
      </div> -->
        <!-- Submit Button -->
        <div class="form-group button-control">
          <BaseButton color="GRAY" @click="cancelEdit">CANCEL</BaseButton>
          <BaseButton color="PURPLE" @click="confirmEdit">COMFIRM</BaseButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/global/BaseButton.vue";

export default {
  name: "CategoryEditor",
  components: {
    BaseButton,
  },
  props: {
    categoryId: String,
    categoryName: String, // 新增prop以接收类别名称
  },

  methods: {
    cancelEdit() {
      this.$emit("cancel");
    },

    confirmEdit() {
      this.$emit("confirm", this.localCategoryName);
      // 其他确认逻辑...
    },
  },
  data() {
    return {
      localCategoryName: this.categoryName, // 使用prop初始化本地状态
    };
  },
  watch: {
    // 如果prop更新，也更新本地状态
    categoryName(newVal) {
      this.localCategoryName = newVal;
    },
  },
};
</script>

<style>
/* 自製 radio 按鈕 */
.radio-container {
  display: flex;
  flex-direction: row; /* 改為橫向排列 */
  gap: 20px; /* 按鈕之間的間隔 */
  justify-content: left;
}

.rdobutton_label {
  position: relative;
  display: block;
  width: 20px; /* 縮小寬度 */
  height: 20px; /* 縮小高度 */
  cursor: pointer;
  border-radius: 50%; /* 圓形 */
  -moz-transition: background-color 0.2s ease-in;
  -webkit-transition: background-color 0.2s ease-in;
  -o-transition: background-color 0.2s ease-in;
  transition: background-color 0.2s ease-in;
}

.rdobutton_label::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px; /* 縮小內圓尺寸 */
  height: 12px; /* 縮小內圓尺寸 */
  background-color: white;
  border-radius: 50%; /* 圓形 */
  opacity: 0;
  transform: translate(-50%, -50%); /* 使圓形居中 */
  -moz-transition: opacity 0.2s ease-in;
  -webkit-transition: opacity 0.2s ease-in;
  -o-transition: opacity 0.2s ease-in;
  transition: opacity 0.2s ease-in;
}

.rdobutton_radio:checked + .rdobutton_label::before {
  /* 當選中時，內部圓形出現 */
  opacity: 1;
}

.rdobutton_radio {
  display: none;
}
.category-editor {
  width: 400px !important; /* 調整卡片寬度 */
  margin: auto;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.border-Control {
  border-radius: 6px;
  margin: 0;
}
.button-control {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0px 60px;
}
.modal-sheet {
  position: fixed; /* 或者absolute，取决于需求 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明遮罩 */
  z-index: 1050; /* 确保遮罩层在顶层 */
}

.category-editor {
  z-index: 1051; /* 确保模态窗在遮罩层之上 */
  /* 其他样式保持不变 */
}
</style>
